import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";

import { Helmet } from "react-helmet";

import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import AllAgenciesContent from "./AllAgenciesContent";

import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import BannerRectangle from "../../Banner/BannerRectangle";

import { translate, getLanguage } from "../../Translation/Translation";

const styles = {
  paragraph: {
    lineHeight: "48px",
    color: "#293f54",
    fontSize: 28,
    padding: "20px 0px",
  },
};

class Allagencies extends Component {
  render() {
    return (
      <div>
        <Grid fluid className="no-padding">
          <Helmet>
            <title>Travel Agents | Openseas</title>
            <meta
              name="description"
              content="Η Openseas συνεργάζεται με 7152 ταξιδιωτικά γραφεία σε 14 χώρες. Επιλέξτε το γραφείο που σας ενδιαφέρει και ενημερωθείτε για τα διαθέσιμα δρομολόγια. Openseas το επόμενο ταξίδι σας σε 3 κλίκ!"
            />
          </Helmet>
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header data={this.props} />
            </Col>
          </Row>
          <Row>
            <div className="OSPageContainer">
              <div className="OSPageContent">
                <p style={styles.paragraph}>
                  {translate(
                    getLanguage(),
                    "Research you next travel agency! Pick country, region or municipality and organise your next trip today!"
                  )}
                </p>
                <AllAgenciesContent
                  agencies={this.props.data.agencies}
                  setCountry={this.props.data.setAgencyCountryId}
                  setPerfecture={this.props.data.setAgencyPerfectureId}
                  setMunicipality={this.props.data.setAgencyMunicipalityId}
                  setAgencyList={this.props.data.setAgenciesList}
                  language={getLanguage()}
                />
                <Row style={{ margin: "24px 0px 24px 0" }}>
                  <div className="displayBannerLarge">
                    <BannerRectangleLarge agency="Y" />
                  </div>
                </Row>
                <Row>
                  <Col xs={12} sm={6} mdHidden lgHidden>
                    <BannerRectangle agency="Y" />
                  </Col>
                  <Col xsHidden sm={6} mdHidden lgHidden>
                    <BannerRectangle agency="Y" />
                  </Col>
                </Row>
              </div>
              <div className="OSPageSidebar">
                <Sidebar agency="Y" />
              </div>
            </div>
          </Row>
          <Row style={{ margin: "0px" }}>
            <Footer />
          </Row>
        </Grid>
      </div>
    );
  }
}
export default Allagencies;



// WEBPACK FOOTER //
// ./src/components/Pages/Allagencies/Allagencies.js